import t from 'js/utils/translate';
import { ApiPackageInfo } from 'src/interfaces/interfaces.generated';

export const extendReturnDateToggleLabel = (packageInfo: ApiPackageInfo): string =>
  `${t('order.edit.servicepoint.extendReturnBy', packageInfo?.deadlineExtensionDays)}`;

export const extendReturnDateToggleSubLabel = (deliveryDeadline: string): string =>
  `${t('order.edit.servicepoint.returnDate', deliveryDeadline)}`;
